import { ref, remove, get, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetProformaInvoiceDataFirebase from "./GetProformaInvoiceDataFirebase";

const DeleteProformaInvoiceDataInFirebase = async (state, dispatch, uniqueID, userId) => {

    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);
    console.log("uniqueID", uniqueID);

    if (!USERID) return null;

    try {

        // Reference to the specific invoice in Firebase
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/proforma/${uniqueID}`);

        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Invoice not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });


        // Fetch updated invoice data after deletion
        await GetProformaInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "Proforma Invoice deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete Proforma invoice." };
    }
};

export default DeleteProformaInvoiceDataInFirebase;
